import {
  Backdrop,
  Box,
  CircularProgress,
  Paper,
  Typography,
} from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { React, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Progress_bar from "./Progress_bar";
import { setState } from "./dashBoardSlice";
import muiConfig from '../../assets/MuiConfig.json'

export default function RunningPeriodStatus() {
  const state = useSelector((store) => store.dashboard);
  const dispatch = useDispatch();
  const { isLoading, drawerOpen, scenarios } = state;

  const columns = [
    {
      field: "scenarioName",
      headerName: "Scenario Name",
      flex: 2,
    },
    {
      field: "quota",
      headerName: "Quota",
      flex: 1,
      valueFormatter: (params) => {
        const formattedValue = Number(params.value)?.toLocaleString('en-US');
        return formattedValue;
      },
    },
    {
      field: "consumption",
      headerName: "Quota Consumption",
      flex: 2,
      renderCell: (cellValues) => {
        let progressBarValue = 0;
        if (cellValues.row.quota == 0.0) {
          progressBarValue = 0;
        } else {
          progressBarValue = (
            (cellValues.row.consumption / cellValues.row.quota) *
            100
          ).toFixed();
        }
        let progressBarColor = "#FFC0C0"; 
        return (
          <Box sx={{ width: "100%",display:'flex',alignItems:'center',justifyContent:'space-between' }}>
            <Progress_bar
              //bgcolor="#007bff"
              progress={progressBarValue}
              progressContent={cellValues.row.consumption?.toLocaleString('en-US')}
              height={30}
              bgcolor={progressBarColor}
            />

            <label style={{marginLeft:'10px'}}>{progressBarValue + "%"}</label>
          </Box>
        );
      },
    },
    {
      field: "orderStatus",
      headerName: "Order Status",
      flex: 2,
      //headerAlign:"center",
      //align: "center",
      renderCell: (cellValues) => {
        let styles = {
          border: "1px solid green",
          color: "green", 
          borderRadius: "16px",
          padding: "4px 12px",
          textAlign: "center",
        };
        let bgColor = "E8FCEF";
        if (cellValues.value === "Blocked") {
          bgColor = "#FFE9E9";
          styles.border = "1px solid red";
          styles.color = "#FF2929";
        } else if (cellValues.value === "Blocked and Reviewed") {
          bgColor = "#FFF4E2";
          styles.border = "1px solid #E36900";
          styles.color = "#E36900";
        }
        else if (cellValues.value === "Normal") {
          bgColor = "#E8FCEF";
          styles.border = "1px solid green";
          styles.color = "#197E37";
        }
    
        return (
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
              px: 5,
              py: 1,
              marginLeft:"20px",
              borderRadius: "16px",
              backgroundColor: `${bgColor} !important`,
              color: "black !important",
              width:"fit-content",
              textAlign:"center",
              ...styles
            }}
          >
            {cellValues.value}
          </Box>
        );
      },
    },
    
  ];

  useEffect(() => {
    dispatch(setState("scenarios", []));
    dispatch(
      setState("approvalStats", {
        scenarioCount: 0,
        quotaCount: 0,
        quotaModificationsCount: 0,
      })
    );
  }, []);

  return (
    <>

      {scenarios.length > 0 && !isLoading ? (
        
        <Paper
          elevation={0}
          sx={{
            width: drawerOpen ? "75%" : "100%",
            borderRadius: 2,
            paddingTop: 2,
          }}
        >
          <Typography
            variant="subtitle1"
            gutterBottom
            sx={{ color: "#000000" }}
          >
            Running Period Status
          </Typography>

          <DataGridPro
            style={{ maxHeight: "calc(100vh - 130px)" }}
            disableColumnMenu
            sx={{
              "& .MuiDataGrid-columnHeaderTitle": {
                whiteSpace: "normal",
                lineHeight: "normal",
              },
              "& .MuiDataGrid-columnHeader": {
                position: "sticky",
              },
              "& .MuiDataGrid-columnHeaders": {
                maxHeight: "168px !important",
              },
              "& .MuiDataGrid-columnHeader[data-field='orderStatus']": {
                paddingLeft: "20px", // Apply specific padding to the 'Order Status' header
              },
            }}
            rowHeight={70}
            rows={scenarios || []}
            columns={columns}
            getRowId={(scenarios) => scenarios?.scenarioID}
            initialState={{
                  pagination: { paginationModel: { pageSize:20, page:0 }}
            }}
            pagination
            pageSizeOptions={[20, 50, 100, { value: muiConfig.DataGrid_All , label: 'All' }]}
            disableRowSelectionOnClick
            disableVirtualization={false}
          />
        </Paper>
      ) :  ( 
         <Paper

          elevation={0}
          sx={{
            width: drawerOpen ? "75%" : "100%",
            borderRadius: 2,
            paddingTop: 2,
            visibility:isLoading ? "hidden":"visible" 
          }}
        >
          <Typography variant="subtitle1" sx={{ color: "#000000", mt: 1 }}>
            Running Period Status
          </Typography>
          <DataGridPro
            sx={{ height: "300px", mt: 1,
              visibility:isLoading ? "hidden":"visible" 
             }}
            rows={[]}
            columns={columns}          
            initialState={{
              pagination: { paginationModel: { pageSize:20, page:0 }}
            }}
            pagination
            pageSizeOptions={[20, 50, 100, { value: muiConfig.DataGrid_All , label: 'All' }]}
            disableColumnMenu
            disableRowSelectionOnClick
          />
        </Paper> 
       )} 
    </>
  );
}
